export default function () {
    // write in console window.addGrid() to show grid in frontend
    function addGrid() {
        const $body = $('body');
        if ($('.module-grid').length === 0) {
            $body.append(
                '<div class="module-grid container">'
                + '<div class="row">'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div>'
                + '<div class="col-xs-1"></div></div></div>',
            );
            $('.module-grid').height(document.body.clientHeight);
            $body.addClass('show-grid');
            $('.module-grid').on('click', () => {
                $('body').removeClass('show-grid');
                $('.module-grid').remove();
            });
        }
    }

    window.addGrid = addGrid;
}
